import * as T_T from 'cryface';
import { Models } from '../../../models/models';
import { CommonConfig } from '../../../configs/config.common';
import { MapEpicListDelegate } from '../../../services/DataDelegate/MapEpic/list.delegate';
import { ESearchType } from '../../../models/property.map.epic';
import { AxiosPromise } from '../../../utils/axios.promise';
export namespace MapEpicStates {
    export function factory() {
        const mapEpic = {
            timestamp: new Date(),
            list: [],
            totalRecords: 0,
            page: 1,
            totalPage: 0,
            centerLocation: { lat: 43.6529, lng: -79.3849 },
            searchText: '',
            searchType: ESearchType.Address,
            buffer: undefined,
            hoveredProperty: undefined,
            filtersSimple: Models.initMapListSimpleFilters(),
            houCondition: {
                lowestPrice: 200,
            },
            mapPageDetailObject: null,
            mapPageDetailReset: false,
        };
        return mapEpic;
    }
    export function actions() {
        return {
            async MLSNumberSearch({ commit, state }: any, mlsNumber: any) {
                const configs = new CommonConfig();
                const url = configs.cmisapiHost + '/mh/selectBy';
                const fetched = await AxiosPromise.get(url + `?selectBy=${mlsNumber}&cityid=1`);
                state.mapEpic.searchType = ESearchType.MlsNumber;
                state.mapEpic.searchText = mlsNumber;
                if (fetched && fetched.data && fetched.data.houlist && fetched.data.houlist.length) {
                    commit('setMLSNumberSearch', fetched.data.houlist);
                } else {
                    commit('setMLSNumberSearch', []);
                }
            },
            async addressSearch({ commit, state, dispatch }: any, { googleVal, mapFetchingCallback, filters }: any) {
                state.mapEpic.searchType = ESearchType.Address;
                state.mapEpic.searchText = googleVal.name;
                const lng = typeof googleVal.geometry.location.lng === 'function'
                    ? googleVal.geometry.location.lng()
                    : googleVal.geometry.location.lng;
                const lat = typeof googleVal.geometry.location.lat === 'function'
                    ? googleVal.geometry.location.lat()
                    : googleVal.geometry.location.lat;
                commit('setCenter', { lat: lat, lng: lng });
                if (filters) {
                    commit('setSimpleFilters', filters);
                    commit('updateHouCondition');
                } else {
                    throw Error('No filters input');
                }
                const houCondition = state.mapEpic.houCondition;
                houCondition.latitude = lat;
                houCondition.longitude = lng;
                houCondition.radius = 812;
                state.mapEpic.hoveredProperty = null;
                const query = {
                    houCondition: houCondition,
                    page: 1,
                    callback: mapFetchingCallback,
                };
                await dispatch('fetchMapList', query);
            },
            async fetchMapList({ state }: any, query: any) {
                const mapService = new MapEpicListDelegate();
                const configs = new CommonConfig();
                // add Filters
                // const filters: any = query.filters;
                // state.mapEpic.filtersSimple = filters;
                // console.log(filters, 'filters');
                // fetch data
                if (!T_T.simpleDetect(query.houCondition.lowestPrice)) {
                    query.houCondition.lowestPrice = 200;
                }
                const dataFetched = await mapService.getListByPage(query.houCondition, query.page, {
                    name: query.houCondition.sortBy,
                    descOrAsc: query.houCondition.descOrAsc
                });
                if (dataFetched.code === 200) {
                    const data: any = dataFetched.data;
                    state.mapEpic.timestamp = new Date();
                    state.mapEpic.list = data.map((v: any) => {
                        v.pictures = T_T.simpleDetect(v.pictures) ? v.pictures.slice(0, 5) : [configs.housePicPlaceHolder];
                        return v;
                    });
                    state.mapEpic.totalRecords = dataFetched.totalRecord;
                    state.mapEpic.page = query.page;
                    state.mapEpic.houCondition = query.houCondition;
                    state.mapEpic.totalPage = dataFetched.totalPage;
                }
                if (T_T.simpleDetect(query.callback)) {
                    await query.callback();
                }
                // console.log(dataFetched, 'fetchMapList');
            },
        };
    }
    export function mutations() {
        return {
            setCenter(state: any, data: any) {
                state.mapEpic.timestamp = new Date();
                state.mapEpic.centerLocation = data;
            },
            saveSearchText(state: any, text: string) {
                state.mapEpic.timestamp = new Date();
                state.mapEpic.searchText = text;
            },
            saveSearchType(state: any, searchType: ESearchType) {
                state.mapEpic.searchType = searchType;
            },
            saveMapBuffer(state: any, buffer: any) {
                if (T_T.simpleDetect(buffer.list)) {
                    if (buffer.list.length > 0) {
                        state.mapEpic.timestamp = new Date();
                        state.mapEpic.buffer = buffer;
                    }
                }
            },
            setMapPageDetailObj(state: any, obj: any) {
                state.mapEpic.mapPageDetailObject = obj;
            },
            setMapPageDetailReset(state: any, mapPageDetailReset: boolean) {
                state.mapEpic.mapPageDetailReset = mapPageDetailReset;
            },
            async activateMapPageDetailReset(state: any) {
                state.mapEpic.mapPageDetailReset = false;
                await T_T.delay(100);
                state.mapEpic.mapPageDetailReset = true;
            },
            setHoveredProperty(state: any, identifier: any) {
                state.mapEpic.timestamp = new Date();
                state.mapEpic.hoveredProperty = identifier;
            },
            setSimpleFilters(state: any, filters: any) {
                state.mapEpic.filtersSimple = filters;
            },
            resetSimpleFilters(state: any) {
                state.mapEpic.filtersSimple = Models.initMapListSimpleFilters();
                delete state.mapEpic.houCondition.lowestPrice;
                delete state.mapEpic.houCondition.bedrooms;
                delete state.mapEpic.houCondition.propertyType;
                delete state.mapEpic.houCondition.listingType;
            },
            clearSimpleFilters(state: any) {
                state.mapEpic.filtersSimple = Models.initMapListSimpleFilters();
            },
            setMapList(state: any, data: any) {
                if (data.list.length > 0) {
                    state.mapEpic.timestamp = new Date();
                    state.mapEpic.totalRecords = data.totalRecords;
                    state.mapEpic.list = data.list;
                }
                if (data.list && data.list.length === 0) {
                    state.mapEpic.timestamp = new Date();
                    state.mapEpic.totalRecords = 0;
                    state.mapEpic.list = [];
                }
            },
            updateHouCondition(state: any) {
                const houCondition: any = state.mapEpic.houCondition;
                const globalFilter = state.mapEpic.filtersSimple;
                const conditionRate = globalFilter.filterSimpleListingTypes
                    && globalFilter.filterSimpleListingTypes.length > 0
                    && globalFilter.filterSimpleListingTypes[0] === 'For Rent'
                    ? 100 : 50000;
                if (globalFilter.filterSimplePrice
                    && globalFilter.filterSimplePrice.length === 2
                    && globalFilter.filterSimplePrice[0] !== 0) {
                    houCondition.lowestPrice = globalFilter.filterSimplePrice[0] * conditionRate;
                } else {
                    delete houCondition.lowestPrice;
                }
                if (globalFilter.filterSimplePrice
                    && globalFilter.filterSimplePrice.length === 2
                    && globalFilter.filterSimplePrice[1] !== 100) {
                    houCondition.highestPrice = globalFilter.filterSimplePrice[1] * conditionRate;
                } else {
                    delete houCondition.highestPrice;
                }
                if (globalFilter.filterSimpleBeds
                    && globalFilter.filterSimpleBeds.length > 0
                    && globalFilter.filterSimpleBeds.indexOf('all') === -1) {
                    houCondition.bedrooms = globalFilter.filterSimpleBeds[0];
                } else {
                    delete houCondition.bedrooms;
                }
                if (globalFilter.filterSimpleBaths
                    && globalFilter.filterSimpleBaths.length > 0
                    && globalFilter.filterSimpleBaths.indexOf('all') === -1) {
                    houCondition.washrooms = globalFilter.filterSimpleBaths[0];
                } else {
                    delete houCondition.washrooms;
                }
                if (globalFilter.filterSimpleGarages
                    && globalFilter.filterSimpleGarages.length > 0
                    && globalFilter.filterSimpleGarages.indexOf('all') === -1) {
                    houCondition.garages = globalFilter.filterSimpleGarages[0];
                } else {
                    delete houCondition.garages;
                }
                if (globalFilter.filterSimpleHomeTypes
                    && globalFilter.filterSimpleHomeTypes.length > 0
                    && globalFilter.filterSimpleHomeTypes.indexOf('all') === -1) {
                    houCondition.propertyType = globalFilter.filterSimpleHomeTypes[0];
                } else {
                    delete houCondition.propertyType;
                }
                if (globalFilter.filterSimpleListingTypes
                    && globalFilter.filterSimpleListingTypes.length > 0
                    && globalFilter.filterSimpleListingTypes.indexOf('all') === -1) {
                    if (globalFilter.filterSimpleListingTypes[0] === 'For Sale') {
                        houCondition.listingType = 'Sale';
                    }
                    if (globalFilter.filterSimpleListingTypes[0] === 'For Rent') {
                        houCondition.listingType = 'Lease';
                    }
                } else {
                    delete houCondition.listingType;
                }
                const sortCondition = {
                    sortBy: 'listingCreatedTimestamp',
                    descOrAsc: 0
                };
                if (globalFilter.filterSortBy) {
                    if (globalFilter.filterSortBy === 'time_new2old') {
                        sortCondition.sortBy = 'listingCreatedTimestamp';
                        sortCondition.descOrAsc = 0;
                    }
                    if (globalFilter.filterSortBy === 'price_low2high') {
                        sortCondition.sortBy = 'price';
                        sortCondition.descOrAsc = 1;
                    }
                    if (globalFilter.filterSortBy === 'price_high2low') {
                        sortCondition.sortBy = 'price';
                        sortCondition.descOrAsc = 0;
                    }

                }
                houCondition.sortBy = sortCondition.sortBy;
                houCondition.descOrAsc = sortCondition.descOrAsc;
                state.mapEpic.houCondition = houCondition;
            },
            async setMLSNumberSearch(state: any, houlist: any) {
                const configs = new CommonConfig();
                if (houlist.length) {
                    const list = houlist.map((v: any) => {
                        v.pictures = T_T.simpleDetect(v.pictures) ? [v.pictures] : [configs.housePicPlaceHolder];
                        v.location = {
                            coordinates: v.coor,
                            type: 'Point'
                        };
                        v.listingCreatedTime = v.listingCreatedTimestamp;
                        return v;
                    });
                    state.mapEpic.timestamp = new Date();
                    state.mapEpic.buffer = list;
                    state.mapEpic.centerLocation = { lat: list[0].coor[1], lng: list[0].coor[0] };
                    state.mapEpic.totalRecords = list.length;
                    state.mapEpic.list = list;
                } else {
                    state.mapEpic.timestamp = new Date();
                    state.mapEpic.buffer = [];
                    state.mapEpic.totalRecords = 0;
                    state.mapEpic.list = [];
                }
            }
        };
    }

    export function interpratListingType(listingType: string) {
        if (listingType === 'For Sale') {
            return 'Sale';
        }
        if (listingType === 'For Rent') {
            return 'Lease';
        }
        return listingType;
    }

    export function getSimpleFilteredProperties(store: any) {
        const buffer = T_T.simpleDetect(store.state.mapEpic.list) ? store.state.mapEpic.list : [];
        const filters = store.state.mapEpic.filtersSimple;
        const filtered = buffer.filter((v: any) => {
            if (T_T.simpleDetect(filters.filterSimplePrice) && filters.filterSimplePrice.length === 2) {
                return v.price >= filters.filterSimplePrice[0];
            } else {
                return true;
            }
        }).map((v: any) => {
            const coord = { lat: v.location.coordinates[1], lng: v.location.coordinates[0] };
            v.distanceWithMe = T_T.coordDistance([store.state.mapEpic.centerLocation, coord]);
            return v;
        })
            // .filter((v: any) => {
            //     if (T_T.simpleDetect(filters.filterSimpleBeds)) {
            //         if (filters.filterSimpleBeds.indexOf('+') > -1) {
            //             return v.bedrooms >= Number(filters.filterSimpleBeds.replace('+', ''));
            //         } else {
            //             return Number(v.bedrooms) === Number(filters.filterSimpleBeds);
            //         }
            //     } else {
            //         return true;
            //     }
            // })
            // .filter((v: any) => {
            //     if (T_T.simpleDetect(filters.filterSimpleHomeTypes)) {
            //         return T_T.editDistance(v.propertyType.toUpperCase(), filters.filterSimpleHomeTypes.toUpperCase()) > 0.9;
            //     } else {
            //         return true;
            //     }
            // })
            // .filter((v: any) => {
            //     if (T_T.simpleDetect(filters.filterSimpleListingTypes)) {
            //         return T_T.editDistance(v.listingType.toUpperCase(), interpratListingType(filters.filterSimpleListingTypes).toUpperCase()) > 0.9;
            //     } else {
            //         return true;
            //     }
            // })
            ;
        return filtered;
    }
}
